const Activities = () => {
  const activitiesData = [
    {
      id: 1,
      icon: "bx bxl-dribbble",
      title: "Volunteer",
      title1: "(Art of Living)",
      description:
        "I am a dedicated volunteer at AOL and have been fortunate enough to witness the profound impact of our initiatives firsthand. My passion lies in assisting those in need and actively supporting the development and well-being of children. It's an honor to be part of an organization that shares these values and strives to make a positive difference in the world.",
      duration: "2021-Present",
    },
    {
      id: 2,
      icon: "bi bi-shield-shaded",
      title: "President",
      title1: "(PAIE Cell)",
      description:
        "As the PAIE (People Association for Inner Engineering) Cell Co-ordinator, I lead workshops exploring the link between mind and breath. These sessions foster a supportive environment for participants to learn techniques enhancing their well-being. It's a responsibility I embrace to promote holistic health in our community.",
      duration: "2022-2025",
    },
    {
      id: 3,
      icon: "bi bi-mortarboard",
      title: "Vice President",
      title1: "(Student Council)",
      description:
        "As the Vice President of the Student Council I play a crucial role in managing and coordinating student activities and events. My duties include ensuring effective communication and addressing student needs. I oversee activities, ensure communication, address needs. This position allows me to make a significant impact on our college community.",
      duration: "2024-2025",
    },
    {
      id: 4,
      icon: "bx bxl-dribbble",
      title: "Volunteer",
      title1: "(NSS)",
      description:
        "As an NSS Volunteer, (National Service Scheme) I am dedicated to making positive changes in society. I actively collaborate with like-minded individuals to implement sustainable solutions. I engage in social initiatives, coordinate impactful campaigns, and strive to improve education, health, and environmental awareness for the betterment of our community.",
      duration: "2021-2025",
    },
  ];

  return (
    <section className="min-h-screen bg-bg-secondary px-[9%] py-[10rem] relative" id="activities">
      {/* Custom Shape Divider */}
      <div className="absolute top-0 left-0 w-full overflow-hidden leading-none">
        <svg
          className="relative block w-[calc(162%+1.3px)] h-[72px]"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1200 120"
          preserveAspectRatio="none"
        >
          <path
            d="M1200,0H0V120H281.94C572.9,116.24,602.45,3.86,602.45,3.86h0S632,116.24,923,120h277Z"
            className="fill-bg-primary"
          ></path>
        </svg>
      </div>

      <div className="flex flex-col justify-center items-center relative z-10 pb-[60px]">
        <div className="relative flex justify-center items-center flex-col w-full max-w-[1350px] pt-[40px] gap-3">
          <h2 className="text-[32px] md:text-[42px] text-center font-semibold mt-20 text-white font-rowdies">
            Activities
          </h2>
          <p className="text-[16px] md:text-[18px] text-center max-w-[600px] text-white mb-8">
            Extracurricular activities are the dynamic companions of student life—they bring excitement, teach valuable
            skills, and help me stand out brilliantly. Get ready to dive in, explore my passions, and unleash my full
            potential!
          </p>

          <div className="flex flex-wrap gap-5 justify-center mt-8 w-full">
            {activitiesData.map((activity) => (
              <div
                key={activity.id}
                className="bg-white shadow-[0px_20px_20px_rgba(0,0,0,0.2)] p-12 text-center rounded-lg transition-all duration-300 hover:-translate-y-[10px] hover:shadow-[0_0_30px_rgba(0,0,0,0.2)] w-full sm:w-[48%] lg:flex-none lg:min-w-[250px] lg:max-w-[240px]"
              >
                <div className="mx-auto mb-[15px] w-[50px] h-[50px] bg-accent rounded-full flex justify-center items-center transition-all duration-300">
                  <i className={`${activity.icon} text-[24px] text-white`}></i>
                </div>
                <h4 className="text-[18px] font-bold mb-2 text-black hover:text-blue-500 transition-colors duration-300">
                  {activity.title}
                </h4>
                <h6 className="text-[12px] font-bold mb-2 text-black hover:text-blue-500 transition-colors duration-300">
                  {activity.title1}
                </h6>
                <p className="text-[12px] leading-17 text-black mb-4">{activity.description}</p>
                <span className="inline-block px-4 py-2 text-sm font-bold text-white bg-blue-600 rounded mt-[12px]">
                  {activity.duration}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Activities;
